import { render } from "./PrivacyPolicy.vue?vue&type=template&id=1ce94433"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=1ce94433&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__